module.exports = __webpack_public_path__ + "img/mobile-neck_48x834.06ca1625.png";